import { AccountGroup } from '@galaxy/account-group';
import { User } from '../../core/user';

export const enum ActionTypes {
  INIT = 'init',
  LOAD_USER = 'load user',
  LOAD_USER_SUCCESS = 'load user: success',
  LOAD_USER_ERROR = 'load user: error',
  LOAD_ACCOUNT_GROUPS = 'load account groups',
  LOAD_MORE_ACCOUNT_GROUPS = 'load more account groups',
  LOAD_ACCOUNT_GROUPS_SUCCESS = 'load account groups: success',
  LOAD_ACCOUNT_GROUPS_ERROR = 'load account groups: error',
  SEARCH = 'search',
  UPDATE_PRODUCT_PERMISSIONS = 'update product permissions',
  UPDATE_TAB_PERMISSIONS = 'update tab permissions',
  UPDATE_PAGINATION = 'update pagination',
  REMOVE_ASSOCIATION = 'remove association',
  REMOVE_ASSOCIATION_SUCCESS = 'remove association: success',
  REMOVE_ASSOCIATION_ERROR = 'remove association: error',
  REMOVE_SELECTED_ASSOCIATIONS = 'remove selected associations',
  TOGGLE_ALL = 'toggle all',
  TOGGLE_ROW = 'toggle row',
}

export class Init {
  readonly type = ActionTypes.INIT;
}

export class LoadUser {
  readonly type = ActionTypes.LOAD_USER;
  constructor(readonly payload: { userId: string }) {}
}

export class LoadUserSuccess {
  readonly type = ActionTypes.LOAD_USER_SUCCESS;
  constructor(readonly payload: { user: User }) {}
}

export class LoadUserError {
  readonly type = ActionTypes.LOAD_USER_ERROR;
  constructor(readonly payload: { error: any }) {}
}

export class LoadAccountGroups {
  readonly type = ActionTypes.LOAD_ACCOUNT_GROUPS;
  constructor(readonly payload: unknown) {}
}

export class LoadMoreAccountGroups {
  readonly type = ActionTypes.LOAD_MORE_ACCOUNT_GROUPS;
  constructor(readonly payload: unknown) {}
}

export class LoadAccountGroupsSuccess {
  readonly type = ActionTypes.LOAD_ACCOUNT_GROUPS_SUCCESS;
  constructor(
    readonly payload: { accountGroups: AccountGroup[]; cursor: string; hasMore: boolean; totalResults: number },
  ) {}
}

export class LoadAccountGroupsError {
  readonly type = ActionTypes.LOAD_ACCOUNT_GROUPS_ERROR;
  constructor(readonly payload: { error: any }) {}
}

export class Search {
  readonly type = ActionTypes.SEARCH;
  constructor(readonly payload: { searchTerm: string }) {}
}

export class UpdateProductPermissions {
  readonly type = ActionTypes.UPDATE_PRODUCT_PERMISSIONS;
  constructor(readonly payload: { accountGroupId: string; permissions: string[] }) {}
}

export class UpdateTabPermissions {
  readonly type = ActionTypes.UPDATE_TAB_PERMISSIONS;
  constructor(readonly payload: { accountGroupId: string; tabIds: string[] }) {}
}

export class UpdatePagination {
  readonly type = ActionTypes.UPDATE_PAGINATION;
  constructor(readonly payload: { pageSize: number; pageIndex: number }) {}
}

export class RemoveAssociation {
  readonly type = ActionTypes.REMOVE_ASSOCIATION;
  constructor(readonly payload: { accountGroupId: string }) {}
}

export class RemoveSelectedAssociations {
  readonly type = ActionTypes.REMOVE_SELECTED_ASSOCIATIONS;
}

export class RemoveAssociationSuccess {
  readonly type = ActionTypes.REMOVE_ASSOCIATION_SUCCESS;
  constructor(readonly payload: { accountGroupId: string }) {}
}

export class RemoveAssociationError {
  readonly type = ActionTypes.REMOVE_ASSOCIATION_ERROR;
  constructor(readonly payload: { accountGroupId: string; error: any }) {}
}

export class ToggleAll {
  readonly type = ActionTypes.TOGGLE_ALL;
}

export class ToggleRow {
  readonly type = ActionTypes.TOGGLE_ROW;
  constructor(readonly payload: { accountGroupId: string }) {}
}

export type AccountGroupPermissionsActions =
  | Init
  | LoadUser
  | LoadUserSuccess
  | LoadUserError
  | LoadAccountGroups
  | LoadMoreAccountGroups
  | LoadAccountGroupsSuccess
  | LoadAccountGroupsError
  | Search
  | UpdateProductPermissions
  | UpdateTabPermissions
  | UpdatePagination
  | RemoveAssociation
  | RemoveSelectedAssociations
  | RemoveAssociationSuccess
  | RemoveAssociationError
  | ToggleAll
  | ToggleRow;
